export default "__VITE_ASSET__UO$fO3dY__"